import React from "react";
import { Default, Mobile } from "../../../utils/deviceHelpers";
import { Link as DomLink } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import HomeSharpIcon from "@mui/icons-material/HomeSharp";
import logo from "../../../assets/images/HS-LogoOnly.png";

export default function CareersBanner(props) {
  return (
    <div className="careers-banner">
      <Mobile>
        <img src={logo} alt="Hoover and Strong - The Gold Standard" />
      </Mobile>
      <Default>
        <img src={logo} alt="Hoover and Strong - The Gold Standard" />
        <span className="careers-hiring">
          WE ARE HIRING. <strong>APPLY NOW!</strong>
        </span>
      </Default>
      <Breadcrumbs className="careers-breadcrumbs">
        <DomLink
          to={{
            pathname: "/",
          }}
        >
          <HomeSharpIcon
            sx={{ mr: 0.5, verticalAlign: "middle", paddingBottom: "1px" }}
            fontSize="inherit"
          />
          HOME
        </DomLink>
        <span>
          <strong>CAREERS</strong>
        </span>
      </Breadcrumbs>
    </div>
  );
}
